import React from "react";
import "./Footer.css";

export default function FooterNote() {
  const year = new Date().getFullYear();
  return (
    <div className="footer_note container">
      <p>© {year} Elegro Energy Limited. All rights reserved.</p>
    </div>
  )
}
